module.exports = __webpack_public_path__ + "static/media/flag.9b6c8bbd.png";